import { useState, useEffect } from "react";
import type { Lang } from "../constants/i18n";

function applyLangAttr(lang: Lang) {
  document.documentElement.setAttribute("data-lang", lang);
  document.documentElement.setAttribute("lang", lang === "jp" ? "ja" : "en");
}

export function useLang() {
  const [lang, setLang] = useState<Lang>("en");

  useEffect(() => {
    const saved = localStorage.getItem("lab-lang") as Lang | null;
    const initial = saved && ["en", "jp"].includes(saved) ? saved : "en";
    setLang(initial);
    applyLangAttr(initial);
  }, []);

  const changeLang = (l: Lang) => {
    setLang(l);
    localStorage.setItem("lab-lang", l);
    applyLangAttr(l);
  };

  return { lang, changeLang };
}
